import { Helmet } from "react-helmet-async";
import PageText from "../../components/PageText";

export default function SpotlightPost() {
  const articleJsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: "CHAOTIK featured in the RSI Tactical Strike Groups Org Spotlight",
    author: { "@type": "Organization", name: "CHAOTIK" },
    publisher: {
      "@type": "Organization",
      name: "CHAOTIK",
      logo: {
        "@type": "ImageObject",
        url: "https://chaotik.org/assets/logo-main.png",
      },
    },
    datePublished: "2026-05-01",
    description:
      "CHAOTIK was featured in CIG's official RSI Tactical Strike Groups Org Spotlight. A multi-role org built for freedom in the 'verse — combat, industry, bounty hunting, cargo, exploration and tactical operations.",
    mainEntityOfPage: "https://chaotik.org/blog",
  };

  return (
    <article className="bg-black/40 backdrop-blur-md rounded-lg p-6 sm:p-8 md:p-10 mb-12 text-left border border-red-500/40 shadow-[0_0_20px_rgba(248,113,113,0.35)]">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(articleJsonLd)}</script>
      </Helmet>
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bebas tracking-wide uppercase mb-6 text-white">
        Featured in the RSI Tactical Strike Groups Org Spotlight
      </h1>
      <p className="text-white/60 text-sm mb-8">May 2026</p>

      <PageText>
        <p className="mb-4">
          In the chaos of the &lsquo;verse, thousands of organizations fight to stand out&hellip;
          but only a select few were chosen to be recognized in the official{" "}
          <a
            href="https://robertsspaceindustries.com/en/comm-link/transmission/21082-Tactical-Strike-Groups-Org-Spotlight"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#96000b] underline hover:text-red-400"
          >
            RSI Tactical Strike Groups Org Spotlight
          </a>
          .
        </p>
        <p className="mb-4">And among them&hellip;</p>
        <p className="mb-4 text-2xl sm:text-3xl font-bebas tracking-wider uppercase text-[#96000b]">
          CHAOTIK.
        </p>
        <p className="mb-4">
          Founded in 2955 by pilots who refused to be chained by rigid hierarchy or hollow
          status symbols, CHAOTIK has always been about one thing:
        </p>
        <p className="mb-6 text-xl sm:text-2xl font-bebas tracking-wider uppercase text-white">
          Freedom in the &lsquo;verse.
        </p>
        <p className="mb-2">Freedom to fly your way.</p>
        <p className="mb-2">Freedom to fight your way.</p>
        <p className="mb-6">
          Freedom to build your own story alongside people who actually enjoy playing together.
        </p>
        <p className="mb-4">Now, that spirit has been recognized on a larger stage.</p>
        <p className="mb-4">
          Being featured in the Tactical Strike Groups Org Spotlight isn&rsquo;t just an honor
          &mdash; it&rsquo;s proof that the community we&rsquo;ve built matters. It means that
          when Cloud Imperium looked for organizations actively shaping the future of
          cooperative gameplay, CHAOTIK stood out.
        </p>
        <p className="mb-2">Not because we pretend to be elite.</p>
        <p className="mb-2">Not because we demand military-grade discipline.</p>
        <p className="mb-6">
          But because we show up. We fly together. We adapt. We laugh through the disasters,
          celebrate the victories, and turn every operation into a story worth remembering.
        </p>
        <p className="mb-6 text-lg sm:text-xl font-bebas tracking-wider uppercase text-white">
          Across every continent. In every timezone. Around the clock.
        </p>
        <p className="mb-4">
          Whether it&rsquo;s high-risk combat drops, industrial operations, bounty hunting,
          cargo runs, exploration, or full-scale tactical operations anywhere in the &lsquo;verse
          &mdash; CHAOTIK thrives in the unpredictable.
        </p>
        <p className="mb-6">And the best part?</p>
        <p className="mb-6 text-xl sm:text-2xl font-bebas tracking-wider uppercase text-white">
          We&rsquo;re just getting started.
        </p>
        <p className="mb-2">
          So if you&rsquo;re a veteran pilot looking for a crew that values skill and
          camaraderie&hellip;
        </p>
        <p className="mb-6">
          Or a brand-new citizen searching for people willing to teach, guide, and fight beside
          you&hellip;
        </p>
        <p className="mb-6">This is your invitation.</p>
        <p className="mb-2">Join the pilots who strike fast.</p>
        <p className="mb-2">Join the org built for freedom.</p>
        <p className="mb-6">Join the chaos.</p>
        <p className="mb-6">
          Join CHAOTIK today&hellip; and help shape the next chapter of the &lsquo;verse.
        </p>
        <p className="mb-4">
          The fastest way in is the{" "}
          <a
            href="https://discord.gg/CHAOTIK"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#96000b] underline hover:text-red-400"
          >
            Discord
          </a>
          . The official details live on our{" "}
          <a
            href="https://robertsspaceindustries.com/en/orgs/CHAOTIK"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#96000b] underline hover:text-red-400"
          >
            RSI org page
          </a>
          .
        </p>
      </PageText>
    </article>
  );
}
